<template>
  <vx-card class="min-h-screen">
		<ResponseAlert ref="response" />
		<vs-table
			:sst="true"
			@sort="sort"
      :data="config.rows"
		>
			<template slot="header">
				<vs-row>
					<vs-col class="mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
						<vs-row
							class="justify-between"
							vs-type="flex" vs-w="12">
							<vs-col vs-lg="5" vs-sm="5" vs-xs="12">
							</vs-col>
							<vs-col class="md:mt-0" vs-lg="7" vs-sm="12" vs-xs="12">
								<vs-row
								class="mb-5 mt-5 lg:mt-0"
								vs-type="flex" vs-justify="space-around" vs-w="12">
								<vs-col class="relative" vs-lg="5" vs-md="4" vs-xs="12">
										<i class="vs-icon notranslate icon-scale material-icons null absolute z-50" style="top: 12px; right: 10px">search</i>
										<vs-input class="w-full" placeholder="Search" v-model="config.search" @input="handleSearch"/>
								</vs-col>
								<vs-col class="mt-5 md:mt-0 px-0 md:px-2" vs-lg="4" vs-md="6" vs-xs="12">
									<vs-button @click="models.advance_search=true" class="w-full" color="primary" type="filled">Advance Search</vs-button>
								</vs-col>
								<vs-col class="mt-3 md:mt-0" vs-lg="3" vs-md="6" vs-xs="12">
									<vs-button @click="exportExcel" class="w-full" color="primary" type="filled">Export</vs-button>
								</vs-col>
								</vs-row>
							</vs-col>
						</vs-row>
					</vs-col>
				</vs-row>
      </template>
			<template slot="thead">
				<vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width" :class="row.class">
					{{row.title}}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td v-if="data[indextr].user" :data="data[indextr].user.name">
						{{data[indextr].user.name}}
					</vs-td>

					<vs-td :data="data[indextr].createdAt">
						{{moment(data[indextr].createdAt).format('DD MMMM YYYY')}}
					</vs-td>

					<vs-td :data="data[indextr].amount">
						Rp. {{parseFloat(data[indextr].amount).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')}}
					</vs-td>

					<vs-td :data="data[indextr].totalCash">
						Rp. {{parseFloat(data[indextr].totalCash).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')}}
					</vs-td>

					<vs-td :data="data[indextr].internalStatus" :class="textColor(data[indextr].status)" class="font-bold">
						<small>{{data[indextr].internalStatus}}</small>
					</vs-td>

					<vs-td>
						<div class="flex justify-around">
							<vs-button title="View" color="primary" type="flat" icon="visibility" @click="showDetail(data[indextr])"></vs-button>
							<template v-if="data[indextr].status === 0">
								<vs-button @click="updateWithdraw(data[indextr].id, 1)" title="Approve" color="success" type="flat" icon="done"></vs-button>
								<vs-button @click="reject(data[indextr].id, 2)" title="Reject" color="danger" type="flat" icon="close"></vs-button>
							</template>
						</div>
          </vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<Pagination :config="config" @gotoPage="gotoPage"/>

		<vs-popup button-close-hidden title="Search" :active.sync="models.advance_search">
			<vs-row>
				<vs-col vs-type="flex" class="flex-col pr-1" vs-w="12">
					<vs-row>
						<vs-col class="flex-col pr-1" vs-type="flex" vs-lg="6">
							<label for="start_date">Start Date</label>
							<vs-input
								autocomplete="off"
								type="date"
								v-model="models.start_date"
								class="w-full"/>
						</vs-col>
						<vs-col class="flex-col pl-1" vs-type="flex" vs-lg="6">
							<label for="end_date">End Date</label>
							<vs-input
								name="end date"
								type="date"
								v-model="models.end_date"
								v-validate="vars.endValidate"
								:min="vars.end_date"
								class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('end date')">{{ errors.first('end date') }}</span>
						</vs-col>
					</vs-row>
				</vs-col>
			</vs-row>
			<vs-row class="mt-5">
				<vs-col vs-type="flex" class="flex-col pr-1" vs-w="12">
					<select class="w-full" v-model="models.status">
						<option v-for="(status, index) in masters.statuses" :key="index" :value="status.value">{{status.text}}</option>
					</select>
				</vs-col>
			</vs-row>
			<vs-row class="mt-5">
				<vs-col vs-type="flex" class="flex-col" vs-w="8" vs-xs="12">
					<vs-row>
						<vs-col vs-type="flex" vs-lg="4" class="px-0">
							<vs-button @click="advanceSearch" class="w-full" color="success">Submit</vs-button>
						</vs-col>
						<vs-col vs-type="flex" vs-lg="4" class="px-1">
							<vs-button @click="reset" class="w-full" color="warning">Reset</vs-button>
						</vs-col>
						<vs-col vs-type="flex" vs-lg="4" class="px-0">
							<vs-button @click="models.advance_search = false" class="w-full" color="danger">Cancel</vs-button>
						</vs-col>
					</vs-row>
				</vs-col>
			</vs-row>
		</vs-popup>
		<vs-popup button-close-hidden title="Detail Withdraw" :active.sync="vars.show_withdraw">
			<vs-row>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Account Name</label>
					<p><b>{{vars.withdraw.name}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Date</label>
					<p><b>{{moment(vars.withdraw.createdAt).format('DD MMMM YYYY')}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Total Withdraw</label>
					<p><b>Rp. {{parseFloat(vars.withdraw.amount).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Balance</label>
					<p><b>Rp. {{parseFloat(vars.withdraw.totalCash).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Bank</label>
					<p><b>{{vars.withdraw.bank}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">No Account</label>
					<p><b>{{vars.withdraw.noRek}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Status</label>
					<p><b>{{vars.withdraw.internalStatus}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">Note</label>
					<p><b>{{vars.withdraw.externalStatus || '-'}}</b></p>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">KTP</label>
					<!-- <p><b>{{vars.withdraw.ktpLink || '-'}}</b></p> -->
          <template v-if="vars.withdraw.ktpLink">
            <img :src="this.vars.withdraw.ktpUrl" alt="">
            <span class="text-base cursor-pointer" @click="downloadImage('ktp')">
              <vs-icon icon="file_download"></vs-icon> Download
            </span>
          </template>
          <span v-else>-</span>
				</vs-col>
				<vs-col class="flex-col pr-1 mb-2" vs-type="flex" vs-lg="6">
					<label for="start_date">NPWP</label>
					<!-- <p><b>{{vars.withdraw.npwpLink || '-'}}</b></p> -->
          <template v-if="vars.withdraw.npwpLink">
            <img :src="this.vars.withdraw.npwpUrl" alt="">
            <span class="text-base cursor-pointer" @click="downloadImage('npwp')">
              <vs-icon icon="file_download"></vs-icon> Download
            </span>
          </template>
          <span v-else>-</span>
				</vs-col>
			</vs-row>
			<vs-row class="mt-5">
				<vs-col vs-type="flex" class="flex-col" vs-w="8" vs-xs="12">
					<vs-row>
						<vs-col vs-type="flex" vs-lg="4" class="px-0">
							<vs-button @click="vars.show_withdraw = false" class="w-full" color="danger">Close</vs-button>
						</vs-col>
					</vs-row>
				</vs-col>
			</vs-row>
		</vs-popup>
	</vx-card>
</template>

<script>
import moment from 'moment'
import {getColorStatus} from '@/utils/helpers'
import api from '@/utils/api'
export default {
		name: 'ListUser',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
					api: api.withdraws,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					additional_params: {
						status: null,
						createdAt: null
					},
					search: "",
					debounce: null,
					headers: [{
						title: "User Name",
						value: "name",
						align: "text-left",
						width: "25%",
					}, {
						title: "Date",
						value: "createdAt",
						align: "text-left",
						width: "15%",
					}, {
						title: "Total Withdraw",
						value: "amount",
						align: "text-left",
						width: "15%",
					}, {
						title: "Balance",
						value: "totalCash",
						align: "text-left",
						width: "15%",
					}, {
						title: "Status",
						value: "status",
						align: "text-left",
						width: "15%",
					}, {
						title: "Action",
						value: "",
						class: "text-center",
						width: "15%",
					}],
				},
				models: {
					advance_search: false,
					status: null,
					start_date: null,
					end_date: null
				},
				vars: {
					end_date: moment().format('YYYY-MM-DD'),
					endValidate: '',
					show_withdraw: false,
					withdraw: {}
				},
				masters: {
					statuses: [
						{
							text: 'All Status',
							value: null
						},
						{
							text: 'Waiting Process',
							value: 0
						},
						{
							text: 'Done',
							value: 1
						},
						{
							text: 'Reject',
							value: 2
						}
					]
				},
				moment,
				getColorStatus
			}
		},
		created() {
			const _ = this;
			_.get();
		},
		computed: {
			start_date() {
				return this.models.start_date
			},
		},
    watch: {
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
		methods: {
			get() {
				this.$table.get(this.config)
				.then(() => {
						this.$watch('start_date', () => {
							this.vars.end_date = moment(this.models.start_date).format('YYYY-MM-DD')
							if (moment(this.models.start_date).isAfter(this.models.end_date)) {
								this.models.end_date = moment(this.models.start_date).format('YYYY-MM-DD')
							}
							this.vars.endValidate = this.models.start_date ? 'required' : ''
						})
					})
			},
			sort(orderby) {
				if(orderby !== "") this.$table.sort(this.config, orderby)
			},
			gotoPage(page) {
				this.$table.gotoPage(this.config, page)
			},
			reject(id, status) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: "Confirm",
					text: "Are you sure want to reject this request?",
					acceptText: "Yes",
					cancelText: "No",
					accept: () => {
						this.updateWithdraw(id, status)
					}
				})
			},

			updateWithdraw(id, status) {
				// status: (0: waiting process, 1: done, 2: reject)
				this.$axios.put(`${api.withdraws}/${id}/status`, {
					status
				})
					.then(res => {
						this.$refs.response.setResponse(res.data, 'success');
						this.get()
					})
					.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
			},

			handleSearch() {
				clearTimeout(this.debounce)
					this.debounce = setTimeout(() => {
          			this.config.page = 1
          			this.get()
				}, 300)
			},

			textColor(status) {
				switch (status) {
					case 0:
						return 'text-warning'
					case 1:
						return 'text-success'
					case 2:
						return 'text-danger'
					default:
						break;
				}
			},

			advanceSearch() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						this.models.advance_search = false
						this.config.additional_params.status = this.models.status
						if(this.models.start_date) {
							this.config.additional_params.createdAt = `betweenDate:${moment(this.models.start_date).format('YYYY-MM-DD')},${moment(this.models.end_date).format('YYYY-MM-DD')}`
						}
						this.get()
					}}
				)
			},

			reset() {
				this.config.additional_params.status = null
				this.config.additional_params.createdAt = null

				this.models.start_date = null
				this.models.status = null
				this.models.end_date = null
				this.models.advance_search = false
				this.get()
			},
			showDetail(row){
				this.vars.show_withdraw = true;
				this.vars.withdraw = row;
			},

      downloadImage(type) {
        if (this.vars.withdraw.ktpLink || this.vars.withdraw.npwpLink) {

          fetch(type === 'ktp' ? this.vars.withdraw.ktpLink : this.vars.withdraw.npwpLink)
            .then(response => {
              if (response.headers.get('content-type').startsWith('image')) {
                return response.blob();
              } else {
                throw new Error('Tautan yang diberikan tidak mengarah ke gambar.');
              }
            })
            .then(blob => {
              const imgUrl = URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = imgUrl;
              link.download = `${this.vars.withdraw.name}_${type}.jpg`;
              document.body.appendChild(link);

              link.click();

              link.parentNode.removeChild(link);
            })
            .catch(error => {
              const link = document.createElement('a')
              link.href = type === 'ktp' ? this.vars.withdraw.ktpLink : this.vars.withdraw.npwpLink
              link.target = '_blank';
              link.download = `img-${type}.jpg`

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        }
      },

      exportExcel(){
				const config = this.config
        const additional_params = config.additional_params || {}
        const search = {search: config.search}
        const params = { page: config.page, limit: config.per_page, sortBy: 'id.desc' }
				this.$axios.get(api.exportWithdrawExcel, {
						params: Object.assign(search, additional_params, params),
						responseType: 'blob',
						headers: {
							Authorization: "Bearer " + localStorage.getItem('token')
						}
					}
				).then((response) => {
					const blob = new Blob(
					[response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    const aEle = document.createElement('a');     // Create a label
                    const href = window.URL.createObjectURL(blob);       // Create downloaded link
                    aEle.href = href;
                    aEle.download = `Report Withdraw (${moment().format('DD MMMM YYYY')})`;  // File name after download
                    document.body.appendChild(aEle);
                    aEle.click();     // Click to download
                    document.body.removeChild(aEle); // Download complete remove element
                    window.URL.revokeObjectURL(href) // Release blob object
				});
			},
		},
	}
</script>

<style>

</style>
